import { useState } from 'react';
import { THEME } from '../constants';

interface RangeSliderInputProps {
  disabled?: boolean;
  label?: string;
  min?: number;
  max?: number;
  step?: number;
}

const RangeSliderInput = ({
  disabled = false,
  label,
  min = 0,
  max = 100,
  step = 1,
}: RangeSliderInputProps) => {
  const [value, setValue] = useState(min);

  return (
    <div className="space-y-2">
      {label && <label className="text-sm font-medium text-[#621C43]">{label}</label>}
      <div className="flex items-center gap-4">
        <span className="text-sm text-[#621C43] min-w-[2rem]">{min}</span>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => setValue(Number(e.target.value))}
          disabled={disabled}
          className="flex-1 h-2 bg-[#F8EFF3] rounded-lg appearance-none cursor-pointer accent-[#C0275E] disabled:opacity-50 disabled:cursor-not-allowed"
          style={{
            background: `linear-gradient(to right, ${THEME.primary} ${
              ((value - min) / (max - min)) * 100
            }%, ${THEME.background} ${((value - min) / (max - min)) * 100}%)`,
          }}
        />
        <span className="text-sm text-[#621C43] min-w-[2rem]">{max}</span>
      </div>
      <div className="text-center">
        <span className="text-sm font-semibold text-[#C0275E]">Current value: {value}</span>
      </div>
    </div>
  );
};

export default RangeSliderInput;
